module.exports = __webpack_public_path__ + "6e25b81bd9c1d0570296769b35c0743e.png";